export function booleanToSelectValue(
  value: boolean | undefined,
  options?: {
    fallbackUndefinedValue?: string;
  }
): string {
  if (value === true) return "true";
  if (value === false) return "false";
  return options?.fallbackUndefinedValue ?? "";
}

export function selectValueToBoolean(value: string): boolean | undefined {
  if (value === "true") return true;
  if (value === "false") return false;
  return undefined;
}
